var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.openDialog}},[(_vm.loading)?_c('Loader',{attrs:{"small":"","inverse":""}}):_c('span',[_vm._v("Show bounces")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }